import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import styles from './styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

const VerifyModal = ({ classes, isOpen, onSave, onClose, onCancel }) => {

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        classes: {
          root: classes.dialogRoot,
        },
      }}
    >
      <IconButton
        className={classes.closeButton}
        onClick={onClose}
        aria-label="Close"
        disableTouchRipple
      >
        <CloseIcon />
      </IconButton>

      <DialogTitle id="alert-dialog-title">
        <Typography variant="h2" className={classes.title}>Verify</Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="h5" className={classes.text}>Would you like to send this to <br/> another Internal Point of Contact?</Typography>
      </DialogContent>

      <DialogActions style={{ justifyContent: 'space-around' }}>
        <Button
          color="secondary"
          variant="outlined"
          className={classes.cancelButton}
          onClick={onCancel}
          disableTouchRipple
        >
          No
        </Button>
        <Button
          type="submit"
          color="primary"
          variant="outlined"
          className={classes.saveButton}
          onClick={onSave}
          disableTouchRipple
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(VerifyModal);
